// import airbrake from './initializers/Airbrake'
import * as ErrorCodes from './ErrorCodes'
import * as ErrorReasons from './ErrorReasons'

// inspired by Parse-SDK-JS
// http://docs.parseplatform.org/js/guide/#error-handling
// http://docs.parseplatform.org/js/guide/#error-codes

// extending errors :
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error
// https://stackoverflow.com/questions/1382107/whats-a-good-way-to-extend-error-in-javascript

// IE errors only have stack when thrown
export function getStack () {
  try {
    throw new Error()
  } catch (e) {
    return e.stack
  }
}

export function InternalError (message) {
  this.name = 'InternalError'
  this.message = message
  this.stack = getStack()
}
InternalError.prototype = Object.create(Error.prototype)
InternalError.prototype.constructor = InternalError

export function MissingCoreParameterError (name) {
  this.name = 'MissingCoreParameterError'
  this.message = 'missing ' + name
  this.stack = getStack()
}
MissingCoreParameterError.prototype = Object.create(Error.prototype)
MissingCoreParameterError.prototype.constructor = MissingCoreParameterError

export function PublicError (code, message, options = {}) {
  this.name = 'PublicError'
  this.code = code
  this.message = message
  this.stack = getStack()

  if (options.error) {
    const stack  = this.stack.split('\n')
    const stack2 = options.error.stack.split('\n')

    // v1
    // stack.pop()    // remove weird "process._tickDomainCallback"
    // stack2.shift() // remove useless 'Error'
    // stack2.shift() // remove useless "const stack = new Error().stack;" (line in Api)
    // this.stack = stack.map(line => line.replace('promiseCall.then.error', 'Api._fetch')).concat(stack2).join('\n')

    // v2
    this.stack = stack.concat(['-- underlying error --']).concat(stack2).join('\n')
  }

  if (code === ErrorCodes.INVALID_PARAMETER) {
    // TODO: use TS types to remove this (verify at build step)
    // if (!options.parameter || !options.reason) {
    //   airbrake.notify(new InternalError('missing _parameter_ or _reason_ in PublicError'))
    // }
    this.invalidParameter = options.parameter
    this.invalidReason = options.reason
    this.invalidMisc = options.misc
  }
}
PublicError.prototype = Object.create(Error.prototype)
PublicError.prototype.constructor = PublicError

PublicError.Codes = ErrorCodes
PublicError.Reasons = ErrorReasons

export function UnhandledErrorWithoutStatus (error) {
  this.name = 'UnhandledErrorWithoutStatus'
  this.message = error.message
  this.stack = error.stack
}
UnhandledErrorWithoutStatus.prototype = Object.create(Error.prototype)
UnhandledErrorWithoutStatus.prototype.constructor = UnhandledErrorWithoutStatus

export function UnhandledErrorInQueue (error) {
  this.name = 'UnhandledErrorInQueue'
  this.message = error.message
  this.stack = error.stack
}
UnhandledErrorInQueue.prototype = Object.create(Error.prototype)
UnhandledErrorInQueue.prototype.constructor = UnhandledErrorInQueue

export function NotWrappedError (error) {
  this.name = 'NotWrappedError'
  this.message = error.message
  this.stack = error.stack
}
NotWrappedError.prototype = Object.create(Error.prototype)
NotWrappedError.prototype.constructor = NotWrappedError
